<template>
  <div :data-app-theme="$store.getters.theme" class="launchpad" @click="closeLaunchpad">
    <div class="launchpad-grid" @click.stop>
      <div
        v-for="(app, index) in apps"
        :key="index"
        class="launchpad-app"
        @click="openApp(app)"
      >
        <img :src="app.icon" alt="App Icon" />
        <p>{{ app.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apps: [
        { name: "Photos", icon: require("@/assets/Icons/Photo.webp") },
        { name: "Mail", icon: require("@/assets/Icons/Mail.webp") },
        { name: "Stickies", icon: require("@/assets/Icons/Notes.png") },
        { name: "Portfolio", icon: require("@/assets/Icons/AppStore.png") },
        { name: "Bio", icon: require("@/assets/Icons/IconBioLight.png") },
        { name: "Photopea", icon: require("@/assets/Icons/Photopea.png") },
        { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
        //   { name: "Installing", icon: require("@/assets/Icons/WIP.webp") },
      ],
    };
  },
  methods: {
    closeLaunchpad() {
      this.$store.commit("toggleLaunchpad"); // Closes Launchpad when clicking outside
    },
    openApp(app) {
      const appMutationMap = {
        Photos: "toggleShownPhotos",
        Mail: "toggleShownMail",
        Stickies: "toggleShownStickies",
        // Simulator: "toggleShownSimulator",
        Portfolio: "toggleShownPortfolio",
        Bio: "toggleShownBio",
        Photopea: "toggleShownPhotoEditor",
      };

      const mutationName = appMutationMap[app.name];
      if (mutationName) {
        this.$store.commit(mutationName, true);
        this.$store.commit("changeActiveWindow", app.name);
        this.$store.commit("toggleLaunchpad"); // Close Launchpad when app is clicked
      } else {
        console.warn(`No matching mutation found for app: ${app.name}`);
      }
    },
  },
};
</script>

<style scoped>
/* Fullscreen Background */
.launchpad {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/light.webp");
  background-size: cover;
  background-position: center;
  backdrop-filter: blur(100px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10vh;
  z-index: 9999;
}

.launchpad::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1); /* Adds a subtle overlay */
  backdrop-filter: blur(40px); /* Adds blur effect */
  z-index: -1;
}

[data-app-theme="dark"] .launchpad, .launchpad[data-app-theme="dark"] {
    background-image: url("../assets/dark.webp");
  }

/* Grid Container */
.launchpad-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 30px;
  /* background: rgba(255, 255, 255, 0.2); */
  /* backdrop-filter: blur(25px); */
  border-radius: 15px;
  padding: 20px;
  max-width: 60%;
  width: 90%;
}

/* Individual App Icons */
.launchpad-app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.launchpad-app img {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}

.launchpad-app p {
  margin-top: 5px;
  font-size: 14px;
  color: white;
}

.launchpad-app:hover {
  transform: scale(1.1);
}
</style>
